import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const noStyleButton = (theme: Theme) => css`
  color: ${theme.success.textBase};
  padding: 0;
  word-break: break-word;
  text-decoration: underline;

  @media (min-width: ${dimensions.tablet}) {
    cursor: pointer;
  }
`;
